import { render } from "./ChoosePlateMaterialPage.vue?vue&type=template&id=7a831517&scoped=true"
import script from "./ChoosePlateMaterialPage.vue?vue&type=script&lang=js"
export * from "./ChoosePlateMaterialPage.vue?vue&type=script&lang=js"

import "./ChoosePlateMaterialPage.vue?vue&type=style&index=0&id=7a831517&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a831517"]])

export default __exports__